export default {
    Week: 1,
    Day: 2
}